import type { RouteLocationNamedRaw, RouteRecordRaw } from 'vue-router'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { FILTERED_VIEW_PARAM_NAME } from '@/services/domain/filteredViews/const'
import { ticketInboxIdViewParam } from '@/services/domain/tickets/const'

// There routes are used only as a fallback to properly redirect user when accessing old routes
// Don't add new routes here, add them to the {@see src/routes/user/settings.ts} file instead

export const ticketsSettingsRoute: RouteRecordRaw = {
  path: 'tickets/settings',
  redirect: { name: UserSettingsRoutes.Tickets },
  children: [
    {
      path: 'index',
      redirect: { name: UserSettingsRoutes.TicketsIndex },
    },
    {
      path: 'inboxes',
      redirect: { name: UserSettingsRoutes.TicketsInboxesIndex },
      children: [
        {
          path: 'connect',
          redirect: { name: UserSettingsRoutes.TicketsInboxesConnect },
        },
        {
          path: `:${ticketInboxIdViewParam}`,
          redirect: (to) =>
            ({
              name: UserSettingsRoutes.TicketsInboxesDetails,
              params: to.params,
              query: to.query,
              hash: to.hash,
            }) satisfies RouteLocationNamedRaw,
        },
      ],
    },
    {
      path: 'spam-filter',
      redirect: { name: UserSettingsRoutes.TicketsSpamFilter },
    },
    {
      path: 'general',
      redirect: { name: UserSettingsRoutes.TicketsGeneral },
    },
    {
      path: 'filtered-views',
      redirect: { name: UserSettingsRoutes.TicketsFilteredViewsIndex },
      children: [
        {
          path: 'new',
          redirect: { name: UserSettingsRoutes.TicketsFilteredViewsCreate },
        },
        {
          path: `edit/:${FILTERED_VIEW_PARAM_NAME}`,
          redirect: (to) => {
            return {
              name: UserSettingsRoutes.TicketsFilteredViewsDetails,
              params: to.params,
            } satisfies RouteLocationNamedRaw
          },
        },
      ],
    },
  ],
}
